import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import LoginForm from "./components/LoginForm";

import { LoginProvider } from "./context/LoginContext";
import { useAuth } from "../../context/AuthContext";
import { getDefaultHomePath } from "../../lib/screenAccess";

const Login: React.FC = () => {
  const { token, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token && user) {
      navigate(getDefaultHomePath(user), { replace: true });
    }
  }, [token, user, navigate]);

  return (
    <LoginProvider>
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50">
        <div className="mx-4 w-full max-w-md">
          <div className="rounded-2xl border border-white/20 bg-primary p-8 shadow-2xl">
            <div className="mb-8 text-center">
              <div className="mb-4 flex justify-center">
                <img
                  src="/logo.png"
                  alt="Dom Belloni Logo"
                  className="h-24 w-auto object-contain"
                />
              </div>

              <h1 className="text-3xl font-bold text-white">Dom Belloni</h1>
              <p className="text-lg font-medium text-white/90">
                Sistema de Produção
              </p>
            </div>

            <LoginForm />
          </div>
        </div>
      </div>
    </LoginProvider>
  );
};

export default Login;
